import { render, staticRenderFns } from "./ReviewList.vue?vue&type=template&id=8e6b7d52&scoped=true"
import script from "./ReviewList.vue?vue&type=script&lang=ts"
export * from "./ReviewList.vue?vue&type=script&lang=ts"
import style0 from "./ReviewList.vue?vue&type=style&index=0&id=8e6b7d52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e6b7d52",
  null
  
)

export default component.exports